
<template>
  
<v-layout row wrap>
   <info-window-dialog :marker="infoWindowMarker" :opened="infoWindowBoolMobile" @close="infoWindowBoolMobile = !infoWindowBoolMobile"></info-window-dialog>
  <v-flex xs12>
    <v-card
    class="map"  elevation-1
    >


    <Gmap-Map style="width: 100%;margin-top:20px; " :zoom="7" :center="center" id="mapHgt"  ref="map">

      
      <Gmap-Marker
        v-for="marker in relatedArtefacts"
        :key="marker.location.place_id"
        :position="{
          lng: parseFloat(marker.location.geometry.location.lng),
          lat: parseFloat(marker.location.geometry.location.lat)}"
        :clickable="true" 
        :draggable="false"
        @click="openInfoWindow(marker)"
        >
           <!-- <gmap-info-window :opened="marker.opened" > -->
           <!-- <v-layout>
             <v-flex xs6>
               <p>{{marker.title}}</p>
                <img :src="marker.mainImg[0].url" alt="" height="60px">
                </v-flex>
                <v-flex xs6>
                <p>{{minimize(marker.description,10)}}</p>
            </v-flex>
                <v-divider></v-divider>
            </v-layout> -->
       <!-- <v-card color="white" class="white--text"  style="width :200px">
            <v-container fluid grid-list-lg>
              <v-layout row>
                <v-flex xs6>
                  <div>
                    <div class="black--text">{{marker.title}}</div>
                  
                  </div>
                </v-flex>
                <v-flex xs6>
                    <v-card-media
                      :src="marker.mainImg[0].url"
                      height="125px"
                     
                      
                    ></v-card-media>
                </v-flex>
              </v-layout>
              <v-card-actions>
                <v-btn :to="'/artefacts/'+marker._id">Go To</v-btn>
              </v-card-actions>
            </v-container>
            
          </v-card>
           </gmap-info-window> -->
        
        </Gmap-Marker>
              <slot name="visible">
                 <div style="top: 60px; left: 15px; background-color: #0000FF; color: white; position: absolute; z-index: 100">
                <info-window class="map-info " :marker="infoWindowMarker" :opened="infoWindowBoolDesktop" @close="infoWindowBoolDesktop = !infoWindowBoolDesktop"></info-window>
                </div></slot>
    </Gmap-Map>
   
    </v-card>
    
</v-flex>
  </v-layout>
 

</template>

<script>
import infoWindow from '@/components/Partials/InfoWindow.vue'
import infoWindowDialog from '@/components/Partials/InfoWindowDialog.vue'
export default {
  components:{
    infoWindow,
    infoWindowDialog
  },
  data() {
    return {
        infoWindowMarker:{},
        infoWindowBoolMobile:false,
        infoWindowBoolDesktop:false,
      place: {
        formatted_address: "Add a location or drag marker.",
      }
    };
  },
  props: ["relatedArtefacts"],
  update() {
    this.$refs.map.resize();
  },
  computed: {
    center() {
      return{
          lng:23.3733689 ,
          lat:45.1709992 
      } 
    }
  },
  methods: {
    openInfoWindow(marker) {
      if(window.innerWidth >968)
      this.infoWindowBoolDesktop=true;
      else this.infoWindowBoolMobile = true;
      
      this.infoWindowMarker = marker;
    },
    setMapHeight() {
    var w = window,
    d = document,
    e = d.documentElement,
    g = d.getElementsByTagName('body')[0],
    x = w.innerWidth || e.clientWidth || g.clientWidth,
    y = w.innerHeight|| e.clientHeight|| g.clientHeight;

      var map = document.getElementById("mapHgt");
       map.style.height = y-200 + "px";
       map.style.width = x + "px";
    },
    minimize(str, spaces) {
      if (str.split(" ").length < spaces) return str;
      else
        return (
          str
            .split(" ")
            .slice(0, spaces - 1)
            .join(" ") + "..."
        );
    }
  },
  mounted() {
    this.setMapHeight();
  }
};
</script>


<style>
.toolbar__content {
  width: -webkit-fill-available !important;
}
.map-info {
  z-index: 9999999;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/MultipleLocationsExplore.vue